import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import mainLogo from "../../../assets/images2/logo.png";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const AuthHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname.split("/")[1];

  //   "";
  return (
    <>
      <AppBar position="static" className="header_main">
        {/* <Box component="div" className="app_bar_main site-container"> */}
        <Toolbar>
          {/* <Container sx={{ display: "flex", alignItems: "center" }}> */}
          <Box component="a" className="main_logo_user">
            <img
              src={mainLogo}
              // className="logo"
              alt=""
              onClick={() => {
                navigate("/login");
              }}
            />
          </Box>

          <Box sx={{ display: "flex", flexGrow: "1" }}></Box>

          <Box className="appbar_side" sx={{ gap: "10px", display: "flex" }}>
            <Button
              className={
                pathName && pathName === "login"
                  ? "head-btn head-btn-active"
                  : "head-btn"
              }
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
            <Button
              className={
                pathName && pathName !== "login"
                  ? "head-btn head-btn-active"
                  : "head-btn"
              }
              onClick={() => navigate("/register")}
            >
              Register
            </Button>
          </Box>
          {/* </Container> */}
        </Toolbar>
        {/* </Box> */}
      </AppBar>
    </>
  );
};

export default AuthHeader;
